import {
  ToolbarPopoverActionButton,
  ToolbarPopoverButton,
  type ToolbarPopoverButtonProps,
} from "@-/dev.improve.haniverse.components.ui.toolbar.button.popover";

export type LevelsTopbarReturnToCurrentLevelButtonProps = Pick<
  ToolbarPopoverButtonProps,
  "className" | "disabled"
> & {
  /**
   * Whether the user's current level is currently visible in the levels list viewport. Drives the
   * filled (`IoLocationSharp`) vs. outline (`IoLocationOutline`) icon.
   */
  isCurrentLevelInViewport: boolean;
  onPress?: () => void;
};

/**
 * The "Current" tray pill. Like every tray pill it opens a popover; the scroll itself is the
 * popover's one action, which starts on the press as the popover collapses out of the list's way.
 */
export function LevelsTopbarReturnToCurrentLevelButton({
  className,
  disabled,
  isCurrentLevelInViewport,
  onPress,
}: LevelsTopbarReturnToCurrentLevelButtonProps) {
  const iconName = isCurrentLevelInViewport ? "IoLocationSharp" : "IoLocationOutline";
  return (
    <ToolbarPopoverButton
      accessibilityLabel="Scroll to current level"
      className={className}
      disabled={disabled}
      label="Current"
      name={iconName}
    >
      <ToolbarPopoverActionButton
        disabled={onPress === undefined}
        label={isCurrentLevelInViewport ? "Current level is on screen" : "Scroll to current level"}
        name={iconName}
        onPress={onPress}
        testID="levels-scroll-to-current-level"
      />
    </ToolbarPopoverButton>
  );
}
